'use client'

import type { StaticImageData } from 'next/image'
import { createPngDataUri } from 'unlazy/blurhash'
import { cn } from 'src/utilities/cn'
import NextImage from 'next/image'
import React from 'react'
import type { MediaProps as MediaProps } from '../types'
import getTailwindScreens from '@/lib/common/utils/getTailwindScreens'

export const ImageMedia: React.FC<MediaProps> = (props) => {
  const {
    alt: altFromProps,
    fill,
    imgClassName,
    priority,
    resource,
    size: sizeFromProps,
    src: srcFromProps,
    loading: loadingFromProps,
    style,
  } = props

  let width: number | undefined
  let height: number | undefined
  let alt = altFromProps
  let src: StaticImageData | string = srcFromProps || ''
  const blurhash =
    resource && typeof resource === 'object' && resource.blurhash
      ? createPngDataUri(resource.blurhash)
      : ''

  if (!src && resource && typeof resource === 'object') {
    const {
      alt: altFromResource,
      filename: fullFilename,
      height: fullHeight,
      url,
      width: fullWidth,
    } = resource

    width = fullWidth!
    height = fullHeight!
    alt = altFromResource || ''

    src = url ?? ''
    // src = `${getClientSideURL()}${url}`
  }

  const loading = loadingFromProps || 'lazy'
  const sizes = sizeFromProps
    ? sizeFromProps
    : Object.entries(getTailwindScreens())
        .map(([, value]) => `(max-width: ${value}) calc(${value}*2)`)
        .join(', ')
  return (
    <picture>
      <NextImage
        alt={alt || ''}
        className={cn(imgClassName)}
        fill={fill}
        placeholder="blur"
        blurDataURL={blurhash}
        priority={priority}
        quality={100}
        loading={loading}
        sizes={sizes}
        src={src}
        width={!fill ? width : undefined}
        height={!fill ? height : undefined}
        style={style}
      />
    </picture>
  )
}
